import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";

import { Translation as T, useAmsSelector } from "@awe-web/shared/lib";
import { newValidate, newGetInitialValues, newHasField } from "@awe-web/shared/lib";
import { getRentContractId } from "@awe-web/shared/lib";

import { useInitialize } from "../../../util/react.js";
import { Row, Col } from "../../../components/grid.js";
import { ScreenSection, ScreenHeading, ScreenLoading } from "../../../components/screen.js";
import { TypeArea } from "../../../components/layout.js";
import { B2B_SignUpRequest } from "../../../routing/routes.js";
import { AccountFieldset, ConsentFieldset } from "../../../user/components/form.js";
import { initialize, submit } from "./actions.js";
import SignUpForm from "./sign_up_form";
import { useNavigate } from "react-router-dom";

const REGISTRATION = "FSD0000187";
const INTRODUCTION = "FSD0000188";
const LINK_B2B_SIGN_UP = "ALG0000215";

function SignUpFormWrapper({ onSubmit, onCaptchaChange }) {

  const rentContractId = useSelector((state) => getRentContractId(state));

  const hasField = useAmsSelector((state) => newHasField("register")(state));

  const validate = useAmsSelector((state) => newValidate("register", {
    "Address:email": "Customer:login",
    "AlternativeWebLogin:Login": "Customer:login"
  })(state));

  const initialValues = useAmsSelector((state) => {
    const formInitializer = newGetInitialValues("register");
    const inialValuesFactory = formInitializer(state);
    return inialValuesFactory({
      "rentcontractId": rentContractId,
      "registrationMode": "register",

      [AccountFieldset.PREFIX_KEY]: "",
      [AccountFieldset.NAME]: "",
      [AccountFieldset.SURNAME]: "",
      [AccountFieldset.BIRTHDATE]: "",
      [AccountFieldset.PHONE]: "",
      [AccountFieldset.USERNAME]: "",
      [AccountFieldset.PASSWORD]: "",
      ...(hasField(AccountFieldset.TAX_IDENT) ? { [AccountFieldset.TAX_IDENT]: "" } : {}),

      "tosAccepted": false,

      [ConsentFieldset.MAIL]: false,
      [ConsentFieldset.EMAIL]: false,
      [ConsentFieldset.PHONE]: false
    });
  });

  return (
    <Formik initialValues={initialValues} validate={validate} onSubmit={onSubmit}>
      {(formikProps) => (
        <SignUpForm {...formikProps} hasField={hasField} onCaptchaChange={onCaptchaChange} />
      )}
    </Formik>
  );
}

export default function B2C_SignUp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [captchaToken, setCaptchaToken] = useState();

  const onSubmit = useCallback(async (values, formikProps) => {
    values = { ...values, captchaToken };
    const nextPath = await dispatch(submit(values, formikProps));
    if (nextPath && nextPath.length > 0) {
      navigate(nextPath);
    }
  }, [captchaToken, dispatch, navigate]);

  const onCaptchaChange = useCallback((captchaToken) => {
    setCaptchaToken(captchaToken);
  }, []);

  const init = useCallback(async () => await dispatch(initialize()), [dispatch]);
  const isReady = useInitialize(init);
  if (!isReady) {
    return <ScreenLoading />;
  }

  return (
    <div>
      <ScreenSection main dark>
        <TypeArea>
          <Row>
            <Col desktop={{ cols: 8, offset: 2 }}>
              <ScreenHeading><T code={REGISTRATION} /></ScreenHeading>
              <p>
                <T code={LINK_B2B_SIGN_UP} to={B2B_SignUpRequest.path()} />
              </p>
              <p><T code={INTRODUCTION} /></p>
            </Col>
          </Row>

          <SignUpFormWrapper onSubmit={onSubmit}
            onCaptchaChange={onCaptchaChange} />
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
